import companyLogo from 'assets/funnel/power_serv.jpg';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import heroImg from 'assets/funnel/mecha_927_1.jpg';
import infoHeroImg from 'assets/funnel/mecha_927_2.jpg';
import jobDetailsImg from 'assets/funnel/mecha_927_3.jpg';
import groupImg from 'assets/funnel/mecha_927_4.jpg';

const mecha_927 = {
  documentTitle: "Mechatroniker (m/w/d) im Bereich Verpackungsmaschinen | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Vollzeit · €2.717,63 / Monat · Sieghartskirchen",
    heroTitle: "Mechatroniker (m/w/d) · Verpackungsmaschinen",
    heroSubtitle: "Wartung und Instandhaltung moderner Verpackungsanlagen bei einem traditionellen Lebensmittelbetrieb in Sieghartskirchen.",
    facts: [
      { icon: 'bi-cash-stack',   title: '€ 2.717,63 / Monat',      subtitle: 'Brutto-Mindestlohn + Überzahlung möglich' },
      { icon: 'bi-geo-alt-fill', title: 'Sieghartskirchen',        subtitle: 'Standort · Niederösterreich' },
      { icon: 'bi-clock',        title: '2-Schichtbetrieb',        subtitle: 'inkl. Wochenend- & Bereitschaftsdienst' },
      { icon: 'bi-shield-check', title: 'Sicherer Arbeitsplatz',   subtitle: 'Lebensmittelproduktion' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · Mechatronik & Verpackung",
    heroTitleLines: ["Mechatroniker", "(m/w/d)"],
    facts: [
      { value: "€ 2.717", label: "Brutto-Mindestlohn + Überzahlung möglich" },
      { value: "Vollzeit", label: "Sieghartskirchen, Niederösterreich" },
    ],
    moechtestDuItems: [
      { icon: 'bi-tools',        text: 'Wartungs- und Instandhaltungsarbeiten an anspruchsvollen Produktionsanlagen im Bereich Verpackung durchführen?' },
      { icon: 'bi-cpu',          text: 'technische Störungen während der Produktion eigenständig analysieren und beheben?' },
      { icon: 'bi-graph-up-arrow', text: 'in einem traditionellen Lebensmittelbetrieb mit modernen Anlagen namhafter Hersteller (z. B. Weber, MULTIVAC, GEA) langfristig durchstarten?' },
    ],
    benefits: [
      { icon: 'bi-shield-check', title: 'Sicherer Arbeitsplatz',      desc: 'Sicherer Arbeitsplatz in der Lebensmittelproduktion.' },
      { icon: 'bi-book',         title: 'Strukturierte Einschulung',  desc: 'Strukturierte Einschulung sowie laufende Weiterbildungsmöglichkeiten.' },
      { icon: 'bi-people',       title: 'Kollegiales Team',           desc: 'Mitarbeit in einem engagierten und kollegialen Team.' },
      { icon: 'bi-building',     title: 'Moderne Anlagen',            desc: 'Moderne Produktionsanlagen und Arbeitsumgebung.' },
      { icon: 'bi-clock',        title: 'Geregelter Schichtbetrieb',  desc: 'Geregelte Arbeitszeiten im Schichtbetrieb inkl. entsprechender Schichtzulagen.' },
      { icon: 'bi-tag',          title: 'Mitarbeiterrabatte',         desc: 'Mitarbeiterrabatte auf Produkte des Unternehmens.' },
      { icon: 'bi-cup-hot',      title: 'Betriebskantine',            desc: 'Betriebskantine bzw. Verpflegungsmöglichkeiten vor Ort.' },
      { icon: 'bi-p-square',     title: 'Kostenloser Parkplatz',      desc: 'Kostenfreier Parkplatz am Firmenstandort.' },
    ],
    aufgabenTitle: "Technik, die den Betrieb am Laufen hält.",
    tasks: [
      'Regelmäßige Wartung und Instandhaltung anspruchsvoller Produktionsanlagen',
      'Reparaturarbeiten für einen reibungslosen Produktionsablauf',
      'Technische Überwachung und Störungsbehebung im Bereich Verpackung',
      'Mithilfe bei der Ersatzteilverwaltung im Bereich Verpackung',
    ],
    requirements: [
      'Abgeschlossene technische Berufsausbildung (z. B. Elektrotechnik, Elektronik oder Mechatronik)',
      'Fundierte Kenntnisse in Elektro-, Mechanik- und Pneumatiktechnik',
      'Mindestens 3 Jahre Berufserfahrung in der Instandhaltung und Reparatur industrieller Maschinen oder Verpackungssysteme',
      'Erfahrung mit Anlagen namhafter Hersteller (z. B. Weber, MULTIVAC, GEA oder vergleichbar) von Vorteil',
      'Eigenverantwortliche, lösungsorientierte und kommunikative Arbeitsweise',
      'Bereitschaft zu Schichtarbeit (2-Schicht-Betrieb), Wochenenddiensten sowie Bereitschaftsdienst',
      'Sehr gute Deutschkenntnisse in Wort und Schrift, Englischkenntnisse von Vorteil',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Mechatronik &", "Verpackung"],
    noteText: "Eigenverantwortliche, lösungsorientierte Persönlichkeit mit technischem Know-how? Dann bewirb dich jetzt – wir freuen uns auf dich.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default mecha_927;
